// Laadt de client-plugin van @nuxtjs/supabase (browserclient + auth-state) alleen
// op /admin/. Publieke pagina's halen hun data via /api/data/*; zie nuxt.config.ts.
const isAdmin = (path: string) => path.startsWith('/admin')

export default defineNuxtPlugin({
  name: 'supabase-admin',
  enforce: 'pre',
  async setup(nuxtApp) {
    let loading: Promise<unknown> | undefined
    const load = () => loading ??= import('#supabase-client-plugin')
      .then(({ default: plugin }) => nuxtApp.runWithContext(() => plugin(nuxtApp)))

    if (isAdmin(window.location.pathname)) await load()

    addRouteMiddleware('supabase-admin', async (to) => {
      if (isAdmin(to.path)) await load()
    }, { global: true })
  },
})
